import { useSelector } from 'react-redux';

type PropsType = {
  isDark: boolean;
};

const SelectedPlanBanner = ({ isDark }: PropsType) => {
  const signupContext =
    useSelector((state: any) => state.auth?.profileData?.signupContext) || {};
  const isTrial: boolean = !!signupContext.isTrial;
  const billingPeriod = signupContext.billingPeriod || 'Monthly';

  if (!isTrial && !signupContext.planName) return null;

  return (
    <div
      className={`w-full px-5 py-2 flex flex-col items-center text-center gap-1.5 `}
    >
      <style>
        {`@keyframes trialGlassShimmer {
          0% { transform: translateX(-130%); }
          100% { transform: translateX(130%); }
        }`}
      </style>
      <div className={`text-base ${isDark ? 'text-[#CBD5E1]' : 'text-blue-900'}`}>
        {isTrial ? (
          <>
            <p className="relative overflow-hidden inline-block font-bold text-xl leading-snug">
              <span
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    'linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.6) 50%, transparent 70%)',
                  animation: 'trialGlassShimmer 1.8s linear infinite',
                }}
              />
              {signupContext.trialDays || 15}-day free trial of{' '}
              {signupContext.planName || 'Professional'}
            </p>
            <p className={`text-sm mt-1 ${isDark ? 'text-[#94A3B8]' : 'text-blue-700'}`}>
              Up to{' '}
              {signupContext.trialEmployeeSlotsLabel ||
                (signupContext.trialEmployeeSlots === -1
                  ? 'Unlimited'
                  : signupContext.trialEmployeeSlots)}{' '}
              employees · No payment required.
            </p>
          </>
        ) : (
          <>
            <p className="relative overflow-hidden inline-block font-bold text-xl leading-snug">
              <span
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                   "linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.6) 50%, transparent 70%)",
                  animation: 'trialGlassShimmer 1.8s linear infinite',
                }}
              />
              {signupContext.planName} plan selected
            </p>
            <p className={`text-sm mt-1 ${isDark ? 'text-[#94A3B8]' : 'text-blue-700'}`}>
              {billingPeriod} billing
              {signupContext.effectivePricePerUser != null &&
              signupContext.currencySymbol
                ? ` · ${signupContext.currencySymbol}${Number(signupContext.effectivePricePerUser).toFixed(2)}/user/mo`
                : ''}
            </p>
          </>
        )}
        <p
          className={`mt-1 text-xs font-medium ${
            isDark ? 'text-[#94A3B8]' : 'text-blue-700/80'
          }`}
        >
          Want a different plan? Pick one on the right →
        </p>
      </div>
    </div>
  );
};

export default SelectedPlanBanner;
